import { createContext, useContext, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { useLocalStorage } from "./use_local_storage"

export interface AuthDependacies {
  readonly token: string,
  readonly login: (token: string) => Promise<void>,
  readonly logout: () => Promise<void>
}
const AuthContext = createContext<AuthDependacies>({} as AuthDependacies)

export const AuthProvider = ({ children }: { children: any }) => {
  const navigate = useNavigate()
  const [token, setToken] = useLocalStorage("token", null)

  // call this function when you want to authenticate the user
  const login = async (token: string) => {
    console.log(token)
    setToken(token)
    navigate("/")
  }

  // call this function to sign out logged in user
  const logout = async () => {
    setToken(null)
    navigate("/login", { replace: true })
    console.log("LOGUT")
  }

  console.log(login.toString())
  const value = useMemo<AuthDependacies>(() => ({
    token,
    login,
    logout
  }), [token])
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  return useContext(AuthContext)
}